import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendFormRequest,
  requestFinished,
  setErrors,
  selectFormBody,
  clearAllErrors,
  changeMessage
} from '../../../../common/reducers/forms/requestPasswordResetForm';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';

function* requestPasswordResetFormSaga(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  try {
    yield put(clearAllErrors(reducerName));
    const response = yield call(
      timeoutCall,
      UserService.requestPasswordReset,
      formBody
    );
    if (response) {
      if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
      } else if (response.status === 200) {
        yield put(changeMessage(reducerName, response.data.message));
      }
    }
    yield put(
      requestFinished(reducerName, response.status, response.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendFormRequest(reducerName).type,
      requestPasswordResetFormSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/forms/sagas/requestPasswordResetFormSaga.js